import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import * as styles from './SubtitleLayout.css';
import cn from 'classnames';
import { ContentLayout } from '../ContentLayout';
import { jsx as _jsx } from "react/jsx-runtime";
export var ESubtitleOffset = /*#__PURE__*/function (ESubtitleOffset) {
  ESubtitleOffset["XL"] = "xl";
  return ESubtitleOffset;
}({});
export function SubtitleLayout(_ref) {
  var children = _ref.children,
    offset = _ref.offset;
  return /*#__PURE__*/_jsx("div", {
    className: cn(_defineProperty(_defineProperty({}, styles['container'], true), styles['container-padded'], offset === ESubtitleOffset.XL)),
    children: /*#__PURE__*/_jsx(ContentLayout, {
      children: /*#__PURE__*/_jsx("div", {
        className: styles['content'],
        children: children
      })
    })
  });
}